import initVueApp from "@/core.js";
const component = require(`./../views/CollectionWrapper.vue`).default;
initVueApp(component);
